(function($){
$(document).ready(function() {

    $('.les-focus').slick({
        autoplay: true,
        autoplaySpeed: 5000,
        pauseOnHover: false,
        pauseOnFocus: false,
        focusOnSelect: false,
        arrows: false,
        dots: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 2000,
        fade: true,
        cssEase: 'ease-out',
    });

}); // document.ready
})(jQuery);
